import React, { Component } from 'react';
import Event from '../../../lib/EventEmitter';
import LiveRegion from '../LiveRegion/LiveRegion';

export function sendLiveRegionMessage(message: string) {
  Event.emit(Event.liveRegionMessage.sendLiveRegionMessage, message);
}

type LiveRegionGlobalState = { message: string | undefined };

export default class LiveRegionGlobal extends Component<object, LiveRegionGlobalState> {
  private readonly messageQueue: string[];

  constructor(props: object) {
    super(props);
    this.state = {
      message: undefined,
    };

    this.messageQueue = [];

    this.receiveMessage = this.receiveMessage.bind(this);
    this.processMessage = this.processMessage.bind(this);
  }

  shouldComponentUpdate(_: object, nextState: LiveRegionGlobalState) {
    return nextState.message !== this.state.message;
  }

  componentDidMount() {
    Event.register(Event.liveRegionMessage.sendLiveRegionMessage, this.receiveMessage);
    this.startMessageQueueProcessing();
  }

  componentWillUnmount() {
    Event.remove(Event.liveRegionMessage.sendLiveRegionMessage);
  }

  startMessageQueueProcessing() {
    if (window) {
      window.setInterval(this.processMessage, 350);
    }
  }

  processMessage() {
    if (this.messageQueue && this.messageQueue.length > 0) {
      this.setState({
        message: this.messageQueue.shift(),
      });
    } else if (this.state.message) {
      this.setState({
        message: undefined,
      });
    }
  }

  receiveMessage(message: string) {
    this.messageQueue.push(message);
  }

  render() {
    return (
      <LiveRegion ariaLive="polite" ariaAtomic>
        {this.state.message}
      </LiveRegion>
    );
  }
}
